import React from "react";
import { RiPushpinFill } from "react-icons/ri";
import TableButton from "../../components/Button/TableButton";
import usePin from "./usePin";

const PinButton = ({ type, item, slim }) => {
  const { isPinned, toggle } = usePin(type, item);

  return (
    <TableButton
      danger={isPinned}
      list={slim ? false : true}
      type="button"
      title="Pin Toggle"
      bumpdown={true}
      onClick={toggle}
      style={{ opacity: isPinned ? ".5" : "" }}
    >
      <RiPushpinFill />
    </TableButton>
  );
};

export default PinButton;
